import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function PricingGuide() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How fast can you build my website?',
      answer: 'Most builds are completed in 1–3 weeks depending on content and approvals.',
    },
    {
      question: 'Do you require a deposit?',
      answer: 'Yes—50% to start, and the remaining balance is due before launch.',
    },
    {
      question: 'Can I update my site later?',
      answer: 'Yes. Most clients choose maintenance so updates are handled quickly and professionally.',
    },
    {
      question: 'Do you guarantee Google rankings?',
      answer: 'No one can guarantee rankings, but every site is built with a strong SEO foundation and best practices.',
    },
  ];

  return (
    <div className="bg-white">
      {/* FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <h2 className="font-sora font-bold text-4xl text-charcoal text-center mb-12">
            Frequently Asked Questions
          </h2>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl border border-gray-200 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <span className="font-inter font-semibold text-lg text-charcoal pr-4">
                    {faq.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-2xl text-charcoal transition-transform ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <div className="px-8 pb-6">
                    <p className="font-inter text-base text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <h2 className="font-sora font-bold text-5xl text-charcoal mb-6">
            Ready to upgrade your online presence?
          </h2>
          <p className="font-inter text-xl text-gray-600 mb-10 leading-relaxed">
            If you want a website that looks premium and helps drive customers, let's talk.
          </p>
          <div className="flex items-center justify-center gap-4">
            <Link
              to="/contact"
              className="inline-block bg-primary text-white px-8 py-4 rounded-xl font-inter font-medium text-base hover:bg-primary/90 transition-colors whitespace-nowrap cursor-pointer"
            >
              Book a Call
            </Link>
            <a
              href="mailto:lacruedigitalagency@gmail.com"
              className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 font-medium transition-colors"
            >
              <i className="ri-mail-line"></i>
              Email us for a custom quote
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}